import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'services/alert.service';
import { FriendDetailsService } from 'services/frienddetails.service';

@Component({
  selector: 'app-managepayout',
  templateUrl: './managepayout.component.html',
  styleUrls: ['./managepayout.component.scss']
})
export class ManagepayoutComponent implements OnInit {
  form: FormGroup;
  // routeParams: any;
  // id: number;
  // data: any;
  
  constructor(private formBuilder: FormBuilder
    // private _location: Location,
    // route: ActivatedRoute,
    // private friendDetailsService: FriendDetailsService 
    ) {
    // this.routeParams = route.snapshot.params;
    // this.id = +this.routeParams.id;
     }

  ngOnInit() {
     this.initializeValidators();
    // this.get();
  }

  initializeValidators() {
    this.form = this.formBuilder.group({      
      cusomerName: [], 
      customerNumber: [],
      mobileNumber: [],
      email: []     
    });
  }
  
  // get() {
  //   if (this.id > 0) {
  //     this.friendDetailsService.getBenificiaryInformation(this.id, true).subscribe(result => {
  //       this.data = result;
  //       if (this.data) {
  //         this.form.patchValue(this.data);
  //       }
  //     });
  //   }
  // }

  onSave() {  
  }

  onConfirmCancel() {  
  }


}
